var config = {
    id:"04",
    tagId:"explore-horizontal::prix-explore",
    ratio: {
        width: 640,
        height: 1140
    },
    development: {
        datasUrl: "../../datas/prix-explore/content.json"
    },
    production: {
        datasUrl: "./datas/prix-explore/content.json"
    }
};
module.exports = config;



// WEBPACK FOOTER //
// ./src/config.js